import { render, staticRenderFns } from "./sectionNoticeStatistics.vue?vue&type=template&id=3864e40a&scoped=true&"
import script from "./sectionNoticeStatistics.vue?vue&type=script&lang=js&"
export * from "./sectionNoticeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./sectionNoticeStatistics.vue?vue&type=style&index=0&id=3864e40a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864e40a",
  null
  
)

export default component.exports